import { RoundMultiSelect } from '~/pages/rounds/components/round-multi-select';
import { SeriesSearchSelect } from '~/pages/series/components/serie-select';
import { useUnsavedChangesGuard } from '~/hooks/useUnsavedChangesGuard';
import { schema, Schema } from './division-form.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';

interface Props {
  onSubmit: (data: Schema) => void;
  mode: 'create' | 'edit';
  defaultValues?: Schema;
  isLoading: boolean;
}

export function DivisionForm({ defaultValues, mode, isLoading, onSubmit }: Props) {
  const { formState, register, handleSubmit, watch, setValue, trigger } = useForm({
    defaultValues: defaultValues ?? {},
    resolver: zodResolver(schema),
  });

  const { dialog } = useUnsavedChangesGuard(formState);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="name" label="Namn">
            <Input.Field type="text" {...register('name')} />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="level" label="Nivå">
            <Input.Field type="number" {...register('level')} />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="max_teams" label="Max antal lag">
            <Input.Field type="number" {...register('max_teams')} />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="results_per_round" label="Resultat per runda">
            <Input.Field type="number" {...register('results_per_round')} />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="rounds" label="Serieomgångar">
            <RoundMultiSelect
              {...register('rounds')}
              onChange={values => {
                setValue('rounds', values, { shouldDirty: true });
                trigger('rounds');
              }}
              value={watch('rounds')}
              formState={formState}
              disabled={isLoading}
            />
          </Input.Group>
        </Grid.Item>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="series" label="Serie">
            <SeriesSearchSelect
              {...register('series')}
              placeholder="Sök på serie..."
              onChange={v => {
                setValue('series', v as [string, number], { shouldDirty: true });
                trigger('series');
              }}
              formState={formState}
              value={watch('series')}
            />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Button.Group align="right">
        <Button type="submit" isLoading={isLoading}>
          {{ create: 'Skapa', edit: 'Spara' }[mode]}
        </Button>
      </Button.Group>

      {dialog}
    </form>
  );
}
